/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HIcon64Regular = forwardRef('UiMenuDots3HIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M10.5 32a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0Z" }),
        React.createElement("path", { d: "M50 35.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z" }),
        React.createElement("path", { d: "M32 35.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z" })));
});
